import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
import { logout } from '../../../common/functions/log_out.function';

const API_URL = process.env.REACT_APP_API_URL;

export const getAllUsers = async () => {
  //   const authState = getAuthenticationState();
  try {
    const resp = await apiClient.get(`/users/showAllUsers`, {
      // headers: {
      //   authorization: `Bearer ${authState.token}`
      // }
    });
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
